import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { FormConfigService } from 'src/app/services/form-config.service';
import { FieldFormControl } from 'src/fieldFormControl/FieldFormControl';
import { NoValidatorError } from 'src/fieldFormControl/validators/ValidatorErrors';

export enum MontantValidatorKey {
  limitMontant = 'limitMontant',
  limitParNom = 'limitParNom',
}

export class MontantValidatorsFactory {
  static getValidator(validatorKey: string, config: FormConfigService): ValidatorFn {
    switch (validatorKey) {
      case MontantValidatorKey.limitMontant:
        return limitMontant(config);
      case MontantValidatorKey.limitParNom:
        return limitParNom(config);
      default:
        throw new NoValidatorError('montant', validatorKey);
    }
  }
}

export function limitParNom(config: FormConfigService): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const validatorConfig = config.currentFormConfigSubject.value?.fieldConfigs
      ?.find(config => config.fieldKey === 'montant')
      ?.validators?.find(validator => validator.validatorKey === MontantValidatorKey.limitParNom);
    const threshold = Number(validatorConfig?.parameters?.find(parameter => parameter.key === 'limit')?.value);

    const nom = validatorConfig?.parameters?.find(parameter => parameter.key === 'nom')?.value;

    if (threshold && control instanceof FieldFormControl) {
      const formControl = control as FieldFormControl<string>;
      if (
        nom &&
        formControl.ficheConseilSubject?.value?.investisseur?.nom?.includes(nom) &&
        control.value > threshold
      ) {
        return {
          custom: 'true',
          code: 'limitPourToto',
          message: 'Le montant est limité à ' + threshold + '€ pour toto',
        };
      }
      return null;
    }
    return null;
  };
}

export function limitMontant(config: FormConfigService): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const validatorConfig = config.currentFormConfigSubject.value?.fieldConfigs
      ?.find(config => config.fieldKey === 'montant')
      ?.validators?.find(validator => validator.validatorKey === MontantValidatorKey.limitMontant);
    if (!validatorConfig) {
      return null;
    }
    const threshold = Number(validatorConfig?.parameters?.find(parameter => parameter.key === 'limit')?.value);

    if (threshold && control instanceof FieldFormControl) {
      const formControl = control as FieldFormControl<number>;
      if (control.value > threshold) {
        return { custom: 'true', code: 'custom', message: 'Le montant est limité à ' + threshold + '€' };
      }
      return null;
    }
    return null;
  };
}
